<div class="gps-tracking-page">
  <div class="gps-tracking-status">
    <span class="badge bg-success">{{ activeVehicleCount }} active</span>
  </div>
  <div #mapContainer class="gps-tracking-map"></div>
</div>
